// extracted by mini-css-extract-plugin
export var bioModal = "BioModal-module--bioModal--nVScf";
export var bioModalBody = "BioModal-module--bioModalBody--nqAO1";
export var bioModalDialog = "BioModal-module--bioModalDialog--1PtkK";
export var bioParagraph = "BioModal-module--bioParagraph--bW2+H";
export var closeButton = "BioModal-module--closeButton--hdXye";
export var leftSection = "BioModal-module--leftSection--lSgrd";
export var memberCompany = "BioModal-module--memberCompany--nvWig";
export var memberDesignation = "BioModal-module--memberDesignation--vfzrc";
export var memberName = "BioModal-module--memberName--1gCnJ";
export var modalContent = "BioModal-module--modalContent--Rb08R";
export var profileImage = "BioModal-module--profileImage--rh-0t";
export var rightSection = "BioModal-module--rightSection--sTvut";